<template>
  <div class="album-container">
    <div class="album-back" @click="$emit('albumtab')">
      <span>回到相册 <i class="el-icon-back"></i></span>
    </div>
    <div class="album-img">
      <el-carousel :autoplay="false"  arrow="always" height="670px" :loop="false" :initial-index="indexist" @change="albumTo"  id="carousel"  :key="indexist">
      <el-carousel-item v-for="(item,index) in info" :key="index">
      <div class="carousel-item">
          <div class="gallery-img">
              <img :src="ImgPreUrl+item" height="150%" width="150%"/>
              <div class="gallery-mask"></div>
          </div>
          <div class="carousel-img">
              <img :src="ImgPreUrl+item"/>
          </div>
      </div>
          </el-carousel-item>
      </el-carousel>
      <div class="album-img-title" ref="contentItem">
          <div class="title" v-for="(item,index) in info" :key="index" :class="{'album-tab':indexist===index}" :id="`album-${index}`" @click="albumTo(index)">
          <img v-lazy="ImgPreUrl+item"/>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  components: {},
  props: {
    info:{
      type: Array,
      default: () => []
    },
    indexist:{
      type: Number,
      default: 0
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 相册导航点击事件
    albumTo(index){
      this.indexist=index;
      let room = document.getElementById(`album-${index}`);
      room.scrollIntoView({
        behavior: 'smooth', // 滚动动画：smooth（平滑）/ auto（瞬间）
        block: 'nearest',    // 垂直对齐方式：start（顶部对齐）/ center（居中）/ end（底部对齐）
        inline: 'center'  // 水平对齐方式（默认无需修改）
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.album-img{
    width: 96%;
    padding: 0 1%;
    height: 800px;
    overflow: auto;
}

.carousel-item{
  width: 100%;
  height: 630px;
  background-color: #000;
  position: relative;
}
.gallery-img{
  position: relative;
}
.gallery-mask{
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, .5);
  left: 0;
  position: absolute;
  top: 0;
}
.gallery-img img{
  margin-top: -25%;
  margin-left: -25%;
}
.carousel-img{
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;
    z-index: 9;
    top: 0;
    top: 0;
    img{
      border-radius: 8px;
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      width: 100%;
      max-width: 100%;
    }
}
.album-img-title{
  white-space: nowrap;
  justify-content: center;
  height: 120px;
  width: 100%;
  position: relative;
  overflow-x: auto;
  margin-top: 10px;
  img{
    width: 100%;
    height: 100%;
  }
  .title{
    width: 80px;
    height: 80px;
    display: inline-block;
    border-radius: 6px;
    margin-right: 6px;
    overflow: hidden;
    cursor: pointer;
  }
}
.album-img-title::-webkit-scrollbar {
  display: none; /* 完全隐藏滚动条 */
}
.album-img-title .album-tab{
  img{
    border: 2px solid var(--smtc-color-primary);
    height: 76px;
    width: 76px;
  }
  
}
.album-back{
  width: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #eee;
  border-radius: 0 10px 10px 0;
  margin-top: -10px;
  cursor: pointer;
}
.album-back span{
  width: 20px;
  margin: 0 auto;
}
.Introduction-btn{
  width: 100px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  background-color: var(--smtc-color-primary);
  color: #fff;
  cursor: pointer;
  position: absolute;
  bottom: 36px;
  right: 20px;
}
.star-name{
    display: flex;
    flex-wrap: wrap;
    >div{
        width: 50%;
        text-align: left;
        margin-top: 16px;
        display: flex; 
        i{
            font-size: 16px;
            margin-top: 3px;
            margin-right: 6px;
        }
    }
}
.rooms-feature{
    display: flex;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    text-align: left;
    margin-top: 16px;
}
.album-container{
  width: 100%;
  display: flex;
}
</style>
